import {
  FETCH_AVAILABILITY_REQUEST,
  FETCH_AVAILABILITY_SUCCESS,
  FETCH_AVAILABILITY_FAILURE
} from '../../actionTypes/availabilityActionTypes'

const fetchAvailabilityRequest = partNumbers => {
  const action = {
    type: FETCH_AVAILABILITY_REQUEST,
    payload: partNumbers
  }
  return action
}

const fetchAvailabilitySuccess = data => {
  const action = {
    type: FETCH_AVAILABILITY_SUCCESS,
    payload: data
  }
  return action
}

const fetchAvailabilityFailure = errorDetail => {
  const action = {
    type: FETCH_AVAILABILITY_FAILURE,
    payload: errorDetail.toString()
  }
  return action
}

export { fetchAvailabilitySuccess, fetchAvailabilityFailure, fetchAvailabilityRequest }
